import standardAPI from '@/api/standard_items';

const state = {
  pc_items: [],
  pc_items_status: '',
  pc_items_MetaData: {},
  pc_items_page: 1,
  pc_items_perPage: 10,
};

const responseUrl = '/pc-items';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_pc_items ({ commit }, getOptions) {
    commit('PC_ITEMS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PC_ITEMS_SUCCESS', response);
            commit('PC_ITEMS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PC_ITEMS_READY');
            reject(response);
          } else {
            commit('PC_ITEMS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_pc_item ({ commit, dispatch }, itemData) {
    commit('PC_ITEMS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PC_ITEMS_READY');
          reject(response);
        }
      });
    });
  },
  edit_pc_item ({ commit, dispatch }, itemData) {
    commit('PC_ITEMS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('PC_ITEMS_READY');
          reject(response);
        }
      });
    });
  },
  remove_pc_item ({ commit, dispatch }, itemData) {
    commit('PC_ITEMS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('PC_ITEMS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_pc_item ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_pc_item_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  toggle_pc_item_active ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/active/' + itemData.id,
      method: 'post',
    };
    return new Promise((resolve, reject) => {
      standardAPI.universal_response(preparedData, (response) => {
        console.log(response);
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.pc_items_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.pc_items_perPage = max;
  },
  PC_ITEMS_READY: (state) => {
    state.pc_items_status = 'ready';
  },
  PC_ITEMS_REQUEST: (state) => {
    state.pc_items_status = 'loading';
  },
  PC_ITEMS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.pc_items_MetaData.meta = response.meta;
      state.pc_items_MetaData.links = response.links;
    }
    state.pc_items = response.data;
    state.pc_items_status = 'success';
  },
  PC_ITEMS_ERROR: (state) => {
    state.pc_items_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
